import { ReactNode, useState } from 'react';
import * as Popover from '@radix-ui/react-popover';

import { EQLFilterContext } from './context';
import { EQLFilterValuesContext } from './context';
import { EQLFilterChips } from './EQLFilterChips';
import { EQLFilterContent } from './EQLFilterContent';
import { EQLFilterOverflow } from './EQLFilterOverflow';
import { EQLFilterTrigger } from './EQLFilterTrigger';

export interface EQLFilterProps {
  children: ReactNode;
}

export function EQLFilter({ children }: EQLFilterProps) {
  const state = useState(false);

  return (
    <EQLFilterContext.Provider value={state}>
      <Popover.Root open={state[0]} onOpenChange={state[1]}>
        {children}
      </Popover.Root>
    </EQLFilterContext.Provider>
  );
}

export * from './types';
export { useEQLFilter } from './useEQLFilter';

EQLFilter.Trigger = EQLFilterTrigger;
EQLFilter.Content = EQLFilterContent;
EQLFilter.Chips = EQLFilterChips;
EQLFilter.Overflow = EQLFilterOverflow;
EQLFilter.Values = EQLFilterValuesContext.Provider;
